import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, message, Popconfirm, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import trainApi from "../../../../api/trainApi";
import CheckboxSlider from "../../../../components/SliderList/CheckboxSlider";
import TableWrap from "../../../../components/Table";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { messages } from "../../../../utils/messages";

const ListCategories = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading, isFetching }: any = useQuery(
    ["training_cate", "list-cate"],
    trainApi.getCate
  );
  const mutation = useMutation(trainApi.deleteCate, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries(["training_cate"]);
      }
    },
    onError: (err: any) => {
      message.error(messages.error);
    },
  });
  const update = useMutation(trainApi.editCate, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        queryClient.invalidateQueries(["training_cate"]);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  const handleRemove = (e: any) => {
    mutation.mutate(e);
  };
  const columns: ColumnsType<any> = [
    {
      title: "STT",
      align: "center",
      width: 50,
      dataIndex: "stt",
    },
    {
      title: "Hình ảnh",
      dataIndex: "photo",
      width: "15%",
      className: "td-slider-picture",
      render: (record: string) => {
        return (
          <img
            src={`${process.env.REACT_APP_DOMAIN}${record}`}
            alt=""
            className="slider-picture"
          ></img>
        );
      },
    },
    {
      title: "Tên",
      dataIndex: "ten_vi",
      width: "10%",
    },
    {
      title: "Đề mục",
      dataIndex: "demuc",
      width: "10%",
    },
    {
      title: "Mô tả",
      dataIndex: "mota_vi",
      width: "40%",
    },
    {
      title: "Hiển thị",
      dataIndex: "hienthi",
      align: "center",
      width: 90,
      render: (record: boolean, data: any) => (
        <CheckboxSlider
          _id={data._id}
          check={record}
          dataName="hienthi"
          action={update}
        />
      ),
    },
    {
      title: "Sửa",
      align: "center",
      width: 90,
      render: (_, record: any) => {
        return (
          <EditOutlined
            onClick={() =>
              navigate(`${appRoutes.TRAINING.CATEGORIES.LIST}/${record?._id}`)
            }
          />
        );
      },
    },
    {
      title: "Xóa",
      align: "center",
      width: 90,
      render: (record: any) => {
        return (
          <Popconfirm
            title="Xác nhận xóa mục này"
            style={{ width: "100px" }}
            onConfirm={() => handleRemove(record._id)}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        );
      },
    },
  ];
  return (
    <PageWrap
      title="Danh mục"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Danh mục đào tạo</b>
                </Col>
                <Col>
                  <Button
                    onClick={() =>
                      navigate(`${appRoutes.TRAINING.CATEGORIES.ADD}`)
                    }
                  >
                    <PlusOutlined /> Add
                  </Button>
                </Col>
              </Row>
            }
          />
          <div className="content">
            <TableWrap
              loading={isLoading || isFetching}
              columns={columns}
              isShowTotal
              dataSource={data?.data}
              rowKey="_id"
              bordered
              pagination={false}
              className="hover table-slide"
              hasDefaultColumn={false}
            />
          </div>
        </>
      }
    />
  );
};

export default ListCategories;
